import React, {Component} from "react";
import Dropzone from "react-dropzone";
import Modal from "./Modal";
import {checkMaxFileSize, highlightMaterial} from "./Helpers";
import {Icon, message, Modal as alertModal} from "antd";
import {urlPath} from "./Settings";
import {getAuthHeader} from '../utils/security';

/*eslint no-loop-func: "off"*/
class FileUpload extends Component {
	constructor(props) {
		super(props);
		this.state = {
			alertModalContent: null,
			className: "ix-creative-dropzone",
			dragOverClassName: "ix-creative-dropzone-hover",
			columns: [
				{
					title: "File Name",
					dataIndex: "name",
					width: 150
				},
				{
					title: "Size",
					dataIndex: "formatSize",
					width: 150
				},
				{
					title: "Type",
					dataIndex: "type",
					width: 150
				}
			],
			files: [],
			printAd: null,
			strings: this.props.language,
			tableData: [],
			translations: this.props.translations,
			uploadedFileCloudinaryUrl: "",
			isOnDragEnter: false
		};
		this.handleOk = this.handleOk.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	componentWillReceiveProps() {
		setTimeout(() => !this.isCancelled && this.setState({ strings: this.props.language }), 100);
	}

	handleDelete = () => {
		const { tableData, uploadFiles, selectedRowKeys } = this.state;
		const uploadFilesTmpInit = uploadFiles;
		const uploadFilesTmpEnd = [];
		for (let value in selectedRowKeys)
			for (let file in tableData)
				if (tableData[file].key === selectedRowKeys[value]) {
					//uploadFiles.splice(file, 1);
					uploadFilesTmpEnd.push(uploadFilesTmpInit[file]);
				}
		this.setState({
			tableData: tableData,
			uploadFiles: uploadFilesTmpEnd
		});
	};

	selectedRowKeys = keys => {
		this.setState({ selectedRowKeys: keys });

		const { uploadFiles } = this.state;
		const uploadFilesTmp = uploadFiles;
		const uploadFilesTmpEnd = [];
		for (let value in keys) {
			for (let file in uploadFiles)
				if (uploadFiles[file].key === keys[value]) {
					//uploadFilesTmp.splice(file, 1);
					uploadFilesTmpEnd.push(uploadFilesTmp[file]);
					this.setState({ uploadFilesTmpEnd: uploadFilesTmpEnd });
				}
		}
		return keys;
	};

	error() {
		alertModal.error({
			title: this.props.translations.invalidFileType,
			content: this.state.alertModalContent
		});
	}

	onDrop(files, rejected, evt) {
		//console.log("Dropped " + files.length + " files");
		let items = evt.dataTransfer ? evt.dataTransfer.items : null;
		let reading = 0,
			reading2 = 0;
		var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
		this.setState({ isOnDragEnter: false });

		function scanFiles(entry) {
			reading2++;
			if (entry.isFile)
				entry.file(
					file => {
						file.fullPath = entry.fullPath;
						files.push(file);
						reading2--;
					},
					error => {
						console.error("Cannot convert to file", entry);
						reading2--;
					}
				);
			else {
				reading2--;
				let directoryReader = entry.createReader();
				directoryReader.readEntries(function (entries) {
					entries.forEach(entry => scanFiles(entry));
				});
			}
		}

		for (let index = 0; index < files.length; index++) {
			const file = files[index];
			const bytes = file.size;
			if (files.length > 1 && bytes === 0) {
				// Folder size can be 0 despite having files
				files.splice(index, 1);
				continue;
			}
			var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
			file.formatSize = Math.round(bytes / Math.pow(1024, i)) + " " + sizes[i];
			file.key = index;
			if (items && items[index].webkitGetAsEntry) {
				const item = items[index].webkitGetAsEntry();
				if (item && item.isDirectory) {
					files.splice(index, 1);
					reading++;
					item.createReader().readEntries(function (entries) {
						entries.forEach(function (entry) {
							scanFiles(entry);
						});
						reading--;
					});
				}
			}
		}
		const continueUpload = this.uploadFiles;
		if (reading === 0) continueUpload(files);
		else {
			function checkDone() {
				if (reading > 0 || reading2 > 0) window.setTimeout(checkDone, 100);
				else {
					if (files.length === 0) console.log("No files to upload");
					else continueUpload(files);
				}
			}

			checkDone();
		}
	}

	onDragEnter = () => this.setState({ isOnDragEnter: true });

	onDragLeave = () => this.setState({ isOnDragEnter: false });

	uploadFiles = files => {
		//console.log("FilesFinal", files);
		if (files && files.length > 0) {
			this.props.printAd === "DIGITAL"
				? this.setState({ alertModalContent: this.props.translations.validFileTypes + ": digital" })
				: this.setState({ alertModalContent: this.props.translations.validFileTypes + ": pdf" });
			this.setState({ printAd: this.props.printAd }, function () {
				if ((this.state.printAd === "PRINTED" || this.state.printAd === "NORMAL") && files[0].type === "application/pdf" /* || files[0].type === "application/postscript" */) {
					this.setState({
						tableData: files,
						uploadFiles: files,
						files
					});
					setTimeout(() => files.length === 1 ? this.handleOk() : this.setState({ visible: true }), 100);
				} else if (
					this.state.printAd === "DIGITAL") {
					this.setState({
						tableData: files,
						uploadFiles: files,
						files
					});
					setTimeout(() => files.length === 1 ? this.handleOk() : this.setState({ visible: true }), 100);
				} else this.error();
			});
		} else console.error("FilesFinal are empty!");
	};
	showModal = () => this.setState({ visible: true });

	handleOk = () => {
		const { loadConfig, translations } = this.props;
		let maxSize = loadConfig["web.uploadadmaterial.maxsize"];
		const upload = checkMaxFileSize(this.state.uploadFiles, maxSize);
		if (upload) {
			this.setState({visible: false});
			if (this.props.submitting) this.props.submitting();
			const formData = new FormData();
			const matspecId = this.props.materialSpecificationId;
			const admaterialId = this.props.specId;
			if (this.props.checkedMatspecsArray)
				formData.append("matspec", this.props.checkedMatspecsArray);
			else
				formData.append("matspec", matspecId);
			if (admaterialId)
				formData.append("admaterial", admaterialId);
			formData.append("thumbnailsize", 50);
			const uploadFiles = this.state.uploadFiles;
			let folderUpload = 0;
			for(let i = 0; i < uploadFiles.length; i++) {
				formData.append("files[]", uploadFiles[i]);
				folderUpload += uploadFiles[i].fullPath? uploadFiles[i].fullPath.length: 0;
			}
			if (folderUpload) {
				formData.append("folder", uploadFiles[0].fullPath.substring(1, uploadFiles[0].fullPath.indexOf("/", 2)));
				let paths = "";
				for(let i = 0; i < uploadFiles.length; i++)
					paths += "," + uploadFiles[i].fullPath.substring(1);
				formData.append("paths", paths.substring(1));
			}
			formData.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone)
			const xhr = new XMLHttpRequest();
			xhr.open("POST", urlPath + "/api/upload");
			if (this.props.checkedMatspecsArray) message.loading("Uploading", 25);
			xhr.withCredentials = true;
			xhr.setRequestHeader('Authorization', getAuthHeader().Authorization);
			xhr.onloadstart = () => {
				if (this.props.admaterialUploading) this.props.admaterialUploading(matspecId, admaterialId);
			};
			xhr.onloadend = ev => {
				message.destroy();
				//console.log("Files uploaded successfully", ev, "MaterialSpecification." + matspecId, "AdMaterial." + admaterialId, ev.currentTarget.response);
				if (this.props.admaterialUploaded)
					this.props.admaterialUploaded(JSON.parse(ev.currentTarget.response), matspecId, admaterialId);
				if (this.props.refreshBooking) this.props.refreshBooking(true);
			};
			xhr.send(formData);
		} else
			alertModal.error({
				title: "Error",
				content: translations.fileSizeExceeded + ": " + maxSize + " MB"
			});
	};
	handleCancel = ev => {
		this.setState({
			visible: false,
			tableData: [],
			className: "ix-creative-dropzone",
			files: []
		});
	};

	render() {
		const { strings, className, dragOverClassName, isOnDragEnter } = this.state;
		return (
			<span className="file-upload-root" data-id={this.props.specId}>
				<div className="dropzone">
					<form encType="multipart/form-data" action="">
						<Dropzone
							className={isOnDragEnter ? `${className} ${dragOverClassName}` : className}
							onDrop={this.onDrop.bind(this)}
							onDragEnter={this.onDragEnter.bind(this)}
							onDragLeave={this.onDragLeave.bind(this)}
							onClick={() => highlightMaterial(this.props.specId)}
						>
							<Icon type="upload" />
							<span>{this.props.filePlaceholder}</span>
						</Dropzone>
					</form>
				</div>
				<aside className="fileupload-aside d-none">
					<ul>
						{this.state.files.map(f => (
							<li key={f.name}>{f.name}</li>
						))}
					</ul>
				</aside>
				<Modal
					translations={this.state.translations}
					selectedRowKeys={this.selectedRowKeys}
					modalTitle={strings ? strings.files : "files"}
					tableData={this.state.tableData}
					columns={this.state.columns}
					visible={this.state.visible}
					onOk={this.handleOk}
					onReturn={this.handleCancel}
					onCancel={() => console.log("none")}
					preview={this.state.preview}
					onDelete={this.handleDelete}
				/>
			</span>
		);
	}

	componentWillUnmount() {
		this.isCancelled = true;
	}
}

export default FileUpload;


// WEBPACK FOOTER //
// ./src/components/FileUpload.js